
import Vue from 'vue';
import {
  transformLink,
  TransformLinkReturn,
  transformRichText,
  ValidTransformLinkReturn,
} from '~/transforms/transformComponents';
import {
  mockButtonLink,
  mockAddress,
  mockFooterLeftNav,
  mockFooterRightNav,
  mockSocialLinks,
  mockLegalLinks,
} from './mockData';
import { TransformedCmAccordion } from '~/transforms/transformModules';

export default Vue.extend({
  props: {},
  data() {
    return {
      headline: '' as String,
      button: {} as any,
      address: '' as String,
      emailAddress: '' as String,
      phoneNumber: '' as String,
      navLeftHeadline: '' as String | undefined,
      navLeft: [] as NonNullable<TransformLinkReturn>[],
      navRightHeadline: '' as String | undefined,
      navRight: [] as NonNullable<TransformLinkReturn>[],
      socialLinks: [] as NonNullable<TransformLinkReturn>[],
      legalLinks: [] as NonNullable<TransformLinkReturn>[],
    };
  },
  mounted() {},
  created() {
    // Clear data
    this.headline = '';
    this.button = {};
    this.address = '';
    this.emailAddress = '';
    this.phoneNumber = '';
    this.navLeftHeadline = '';
    this.navLeft = [];
    this.navRightHeadline = '';
    this.navRight = [];
    this.socialLinks = [];
    this.legalLinks = [];

    if (process.env.STORYBOOK_ENABLED) {
      // MOCK DATA FOR STORYBOOK
      this.headline = 'Geiger Gruppe';
      this.button = transformLink(mockButtonLink, '');
      this.address = transformRichText(mockAddress);
      this.phoneNumber = '+49 8322 18 0';
      this.emailAddress = 'info@geigergruppe.de';
      this.navLeftHeadline = 'Über Geiger';
      this.navLeft = mockFooterLeftNav
        .map((menuItem: any) => transformLink(menuItem.link, menuItem.label))
        .filter(e => !!e);
      this.navRightHeadline = 'Karriere';
      this.navRight = mockFooterRightNav
        .map((menuItem: any) => transformLink(menuItem.link, menuItem.label))
        .filter(e => !!e);
      this.socialLinks = mockSocialLinks
        .map((menuItem: any) => transformLink(menuItem.link, menuItem.label))
        .filter(e => !!e);
      this.legalLinks = mockLegalLinks
        .map((menuItem: any) => transformLink(menuItem.link, menuItem.label))
        .filter(e => !!e);
    } else {
      // REAL DATA
      this.headline = this.$marketSettings.footerHeadline;

      // Button
      this.button = transformLink(this.$marketSettings.footerButtonLink, this.$marketSettings.footerButtonLabel);

      // Address
      this.address = transformRichText(this.$marketSettings.address);
      this.phoneNumber = this.$marketSettings.phoneNumber;
      this.emailAddress = this.$marketSettings.emailAddress;

      // Left Menu
      this.navLeftHeadline = this.$marketSettings.footerLeftNavHeadline;
      this.navLeft = this.$marketSettings.footerLeftNav
        .map((menuItem: any) => transformLink(menuItem.link, menuItem.label))
        .filter(e => !!e);

      // Right Menu
      this.navRightHeadline = this.$marketSettings.footerRightNavHeadline;
      this.navRight = this.$marketSettings.footerRightNav
        .map((menuItem: any) => transformLink(menuItem.link, menuItem.label))
        .filter(e => !!e);

      // Social Links Menu
      this.socialLinks =
        this.$marketSettings.socialLinks
          ?.map((menuItem: any) => transformLink(menuItem.link, menuItem.label))
          .filter(e => !!e) ?? [];

      // Legal Links Menu
      this.legalLinks =
        this.$marketSettings.legalLinks
          ?.map((menuItem: any) => transformLink(menuItem.link, menuItem.label))
          .filter(e => !!e) ?? [];
    }
  },
  computed: {
    getAccordionData(): TransformedCmAccordion['data'] {
      return {
        headline: undefined,
        description: undefined,
        headlineSize: undefined,
        collapsibles: [
          { headline: this.navLeftHeadline, content: this.navLeft, contentType: 'footer' },
          { headline: this.navRightHeadline, content: this.navRight, contentType: 'footer' },
        ],
        anchorId: undefined,
      };
    },
  },
});
